/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SelectAll/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'



/** @type {import('Simple/types.js').View} */
export default function SelectAll({
  children,
  viewPath = "/App/Account/Chairs/Content/Filter/Content/SelectAll"
  
}) {
let selectedChairIdsLengthValueData = fromData.useDataValue({ viewPath,
context: 'selected_chair_ids',
path: 'length',
})
let chairsLengthValueData = fromData.useDataValue({ viewPath,
context: 'chairs',
path: 'length',
})
let aggregateData = fromAggregate.equals(selectedChairIdsLengthValueData, chairsLengthValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 text={aggregateData ? "None" : "All"}
 size="small"
 onClick={onClick}
 marginLeft={4}
 data="selected_chair_ids.length"
 data="chairs.length"
 aggregate="/Simple/Data/aggregate.js equals"
 isSelected={aggregateData}
/>
{children}
</React.Fragment>)
}